import React, { useEffect, useState } from 'react';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import {
    TollExpenseHistoryDataForm,
    TollExpenseHistoryFilter
} from '../../../../app/models/TollExpenseHistory';
import { momentParseDate } from '../../../../helpers';

import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';

interface Props {
    tollExpenseHistories: TollExpenseHistoryDataForm[];
    totalRows: number;
    filter: TollExpenseHistoryFilter;
    setFilter: (filter: TollExpenseHistoryFilter) => void;
    edit?: (id: number) => void;
    loading?: boolean;
}

const TollExpenseHistoryDataTable = ({
    tollExpenseHistories,
    totalRows,
    filter,
    setFilter,
    edit,
    loading = false
}: Props) => {
    const columns = [
        {
            name: 'Fecha',
            selector: (row: any) => row?.created_at,
            sortable: true,
            sortField: 'created_at',
            width: '155px',
            cell: (row: TollExpenseHistoryDataForm) => (
                <span className="">{momentParseDate(row?.created_at, 'YYYY-MM-DD HH:mm')}</span>
            )
        },
        {
            name: 'Acción',
            selector: (row: any) => row?.status,
            sortable: true,
            sortField: 'status',
            cell: (row: TollExpenseHistoryDataForm) => <span className="">{row.status}</span>
        },
        {
            name: 'Comentario',
            selector: (row: any) => row.comment,
            sortable: true,
            sortField: 'comment',
            cell: (row: TollExpenseHistoryDataForm) => <span className="">{row.comment}</span>
        },
        {
            name: 'Creado por',
            selector: (row: any) => row.created_user,
            sortable: true,
            sortField: 'created_user',
            width: '250px',
            cell: (row: TollExpenseHistoryDataForm) => 
            <span
                className=""
                dangerouslySetInnerHTML={{ __html: row.created_user ? row.created_user : '' }}
            ></span>
        }
        // {
        //     name: 'Acciones',
        //     selector: (row: any) => row?.id,
        //     sortable: false,
        //     width: '150px',
        //     cell: (row: TollExpenseHistoryDataForm, index: any, column: any) => {
        //         return (
        //             <div className="">
        //                 {edit && !row.is_approved && (
        //                     <ButtonTableAction
        //                         callbackFunction={() => edit(row?.id ?? -1)}
        //                         classIcon={'mdi mdi-pencil'}
        //                         colorIcon={'text-warning'}
        //                         errorMessage={'No se puede editar este registro.'}
        //                         title={'Editar'}
        //                     />
        //                 )}
        //             </div>
        //         );
        //     }
        // }
    ];

    return (
        <DefaultDataTable
            columns={columns}
            data={tollExpenseHistories}
            progressPending={loading}
            isMobileStacked={true}
            paginationTotalRows={totalRows}
            filter={filter}
            setFilter={setFilter}
        />
    );
};

export default TollExpenseHistoryDataTable;
